import { Component, ElementRef, Renderer2, AfterViewInit, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreatureWebFilterDto } from '../../../../../../dtos/creature.web.filter.dto';
import { CreatureType } from '../../../../../../enums/creature.type';
import { RarityType } from '../../../../../../enums/rarity.type';
import { CloseIconComponent } from '../../../../../components/icons/close/close.icon-component';
import { CreatureTypeIconComponent } from '../../../../../components/icons/creature-type/creature-type.icon-component';
import { FormsModule } from '@angular/forms';
import { AbilityDto } from '../../../../../../dtos/ability.dto';
import { AbilitiesService } from '../../../../../../services/abilities.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'filter-creature-component',
  templateUrl: './filter-creature.component.html',
  styleUrls: ['./filter-creature.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    CloseIconComponent,
    CreatureTypeIconComponent,
    TranslateModule
  ]
})
export class FilterCreatureComponent implements OnInit, AfterViewInit {

  public creatureType: typeof CreatureType = CreatureType;
  public creatureRarity: typeof RarityType = RarityType;

  public searchAbility: string = '';
  public lang: string | null = null;

  @Input() filter: CreatureWebFilterDto | null = null;
  @Output() filterChange = new EventEmitter<CreatureWebFilterDto>();

  @Input() showMobile: boolean = false;
  @Output() showMobileChange = new EventEmitter<boolean>();

  constructor(private renderer: Renderer2, private el: ElementRef, private readonly abilitiesService: AbilitiesService, private readonly translateService: TranslateService) {
    this.lang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event) => {
      this.lang = event.lang;
    })
  }

  ngOnInit(): void {
    this.abilitiesService.getAll().subscribe((abilities: AbilityDto[]) => {
      this.allAbilities = abilities;
      this.onSearchAbility();
    });
  }

  ngAfterViewInit(): void {
    const ranges = this.el.nativeElement.querySelectorAll('.dropdown__content-range');
    ranges.forEach((range: HTMLInputElement) => {
      this.updateRangeBackground(range);
      this.renderer.listen(range, 'input', () => this.updateRangeBackground(range));
    });
  }

  toggleDropdown(event: Event): void {
    const button = event.target as HTMLElement;
    const dropdownContent = button?.parentElement?.querySelector('.dropdown__content');
    if (dropdownContent) {
      if (dropdownContent.classList.contains('active')) {
        dropdownContent.classList.remove('active');
      } else {
        dropdownContent.classList.add('active');
      }
    }
  }

  toggleLink(event: Event): void {
    event.preventDefault();
    const link = event.target as HTMLElement;
    link.classList.toggle('active');
  }

  openSidebar(): void {
    const sidebar = this.el.nativeElement.querySelector('.marketplace__sidebar');
    const body = document.body;
    sidebar.classList.add('active');
    body.classList.add('active');
  }

  closeSidebar(): void {
    const sidebar = this.el.nativeElement.querySelector('.marketplace__sidebar');
    const body = document.body;
    sidebar.classList.remove('active');
    body.classList.remove('active');
  }

  private updateRangeBackground(range: HTMLInputElement): void {
    const min = parseFloat(range.min);
    const max = parseFloat(range.max);
    const currentVal = parseFloat(range.value);
    const percentage = ((currentVal - min) / (max - min)) * 100;
    this.renderer.setStyle(range, 'backgroundSize', `${percentage}% 100%`);
  }

  public onChooseCreatureType(type: CreatureType): void {
    const types = this.filter?.types || [];
    const index = types.indexOf(type);
    if (index === -1) {
      types.push(type);
    } else {
      types.splice(index, 1);
    }
    this.filter!.types = types;
    this.updateFilter(this.filter!);
  }

  public isChoosenCreatureType(type: CreatureType): boolean {
    return this.filter?.types?.includes(type) || false;
  }

  public onChooseRarity(rarity: RarityType): void {
    const rarities = this.filter?.rarities || [];
    const index = rarities.indexOf(rarity);
    if (index === -1) {
      rarities.push(rarity);
    } else {
      rarities.splice(index, 1);
    }
    this.filter!.rarities = rarities;
    this.updateFilter(this.filter!);
  }

  public isChoosenRarity(rarity: RarityType): boolean {
    return this.filter?.rarities?.includes(rarity) || false;
  }

  public onChooseAbility(abilityId: string): void {
    const abilities = this.filter?.abilityIds || [];
    const index = abilities.indexOf(abilityId.toString());
    if (index === -1) {
      abilities.push(abilityId.toString());
    } else {
      abilities.splice(index, 1);
    }
    this.filter!.abilityIds = abilities;

    this.selectedAbilityNames = this.allAbilities?.filter((ability: AbilityDto) => {
      return abilities.includes(ability.id.toString());
    }).map((ability: AbilityDto) => ability.name) || [];

    this.updateFilter(this.filter!);
  }

  updateFilter(newFilter: CreatureWebFilterDto): void {
    this.filterChange.emit(newFilter);
  }

  public onFilterChange(): void {
    this.updateFilter(this.filter!);
  }

  public allAbilities: AbilityDto[] | null = null;
  public abilities: AbilityDto[] = [];

  public selectedAbilityNames: string[] | [] = [];

  public onSearchAbility(): void {
    if (this.allAbilities) {
      this.abilities = this.allAbilities.filter((ability: AbilityDto) => {
        return ability.name.toLowerCase().includes(this.searchAbility.toLowerCase());
      });
    }
  }

  public isChoosenAbility(abilityId: string): boolean {
    return this.filter?.abilityIds?.includes(abilityId) || false;
  }
}